var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73585 2.61916C2.90999 2.46788 3.12508 2.37163 3.35392 2.34256C3.58275 2.31348 3.81507 2.3529 4.02152 2.45583L25.0215 12.9558C25.2157 13.0526 25.379 13.2016 25.4931 13.386C25.6073 13.5705 25.6678 13.7831 25.6678 14C25.6678 14.2169 25.6073 14.4295 25.4931 14.614C25.379 14.7984 25.2157 14.9474 25.0215 15.0442L4.02152 25.5442C3.81509 25.6475 3.58267 25.6872 3.35365 25.6583C3.12464 25.6295 2.90933 25.5334 2.73497 25.3821C2.56061 25.2308 2.43503 25.0313 2.37413 24.8086C2.31323 24.586 2.31975 24.3503 2.39285 24.1313L5.38185 15.1667H11.6667C11.9761 15.1667 12.2728 15.0437 12.4916 14.825C12.7104 14.6062 12.8333 14.3094 12.8333 14C12.8333 13.6906 12.7104 13.3938 12.4916 13.175C12.2728 12.9562 11.9761 12.8333 11.6667 12.8333H5.38185L2.39168 3.86866C2.31896 3.64981 2.31272 3.41431 2.37377 3.19192C2.43482 2.96953 2.56158 2.77021 2.73585 2.61916Z",
    fill: "url(#paint0_linear_55_3350)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_3350",
    x1: 3.99897,
    y1: 1.99991,
    x2: 21.9994,
    y2: 26.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F33FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.712ca7fde239dc59527913a8744823cd.svg";
export { ForwardRef as ReactComponent };